import React, { useCallback } from 'react';
import { Icon, icons, AppShell, Colors, Mantine } from '@tapresearch/ui/components';
import { logout } from '../../organization_dashboard/api/UserApi';
export var AccountMenu = function(param) {
    var user = param.user, asset = param.asset;
    var _user_is_ops = user.is_ops, is_ops = _user_is_ops === void 0 ? false : _user_is_ops;
    var customer = user.organization.customer;
    var _user_organization_membership = user.organization_membership, is_admin = _user_organization_membership.is_admin, is_active = _user_organization_membership.is_active;
    var can_developer_survey = user.organization.can_developer_survey;
    var isBannedCustomer = customer && customer.insights_moderation_status === asset.constants.INSIGHTS_MODERATION_STATUS_BANNED;
    var showPayments = !can_developer_survey && is_admin && is_active && customer && customer.customer_type === asset.constants.CUSTOMER_TYPE_PERSONAL;
    var onNavigate = useCallback(function(url) {
        window.location.href = url;
    }, []);
    return /*#__PURE__*/ React.createElement(React.Fragment, null, is_active && !isBannedCustomer && /*#__PURE__*/ React.createElement(React.Fragment, null, !!customer && !can_developer_survey && /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(AppShell.NavbarUserMenuItem, {
        onClick: function() {
            return onNavigate("/ops/customers/dashboard");
        },
        iconKey: icons.tr.TapCircleIcon,
        my: 5,
        py: 7,
        sx: function(theme) {
            return {
                fontSize: theme.fontSizes.sm,
                fontWeight: 500
            };
        },
        rightSection: /*#__PURE__*/ React.createElement(Icon, {
            boxSize: 5,
            color: "gray.200",
            icon: icons.fa.LongArrowAltRight
        })
    }, "Market Sample"), /*#__PURE__*/ React.createElement(Mantine.Menu.Divider, null)), is_ops && /*#__PURE__*/ React.createElement(AppShell.NavbarUserMenuItem, {
        onClick: function() {
            return onNavigate('/organizations/manage');
        },
        iconKey: icons.io5.Business
    }, "Manage"), /*#__PURE__*/ React.createElement(AppShell.NavbarUserMenuItem, {
        onClick: function() {
            return onNavigate("/organizations/".concat(user.organization.identifier, "/team"));
        },
        iconKey: icons.fi.Users
    }, "Team"), !!showPayments && /*#__PURE__*/ React.createElement(AppShell.NavbarUserMenuItem, {
        onClick: function() {
            return onNavigate("/organizations/".concat(user.organization.identifier, "/payments"));
        },
        iconKey: icons.io5.WalletOutline
    }, "Billing"), /*#__PURE__*/ React.createElement(AppShell.NavbarUserMenuItem, {
        onClick: function() {
            return onNavigate("/organizations/".concat(user.organization.identifier, "/account"));
        },
        iconKey: icons.fi.User
    }, "Profile")), /*#__PURE__*/ React.createElement(Mantine.Menu.Divider, null), /*#__PURE__*/ React.createElement(AppShell.NavbarUserMenuItem, {
        color: "red",
        sx: {
            color: Colors.red['500']
        },
        onClick: function() {
            return logout();
        },
        iconKey: icons.fi.LogOut
    }, "Sign out"));
};
